export default __webpack_public_path__ + "static/media/Monk's Boots of Sacrifice.a610a812.jpg";